"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createTheme = _interopRequireDefault(require("../utils/createTheme"));

/**
 * Support for legacy spacing values on the EW front-end.
 */
var spacing = [0, 4, 8, 16, 24, 32, 64, 128, 256, 512];
/**
 * Support for legacy font sizes on the EW front-end.
 */

var fontSizes = [0, 10, 12, 14, 16, 20, 24, 34, 48, 60, 96];
var workLForBusiness = (0, _createTheme["default"])({
  colours: {
    primary: ["#E66F3D", "#FFE3D7", "#FFF6F2"],
    secondary: ["#173C5A", "#CDEAFF", "#E3F3FF", "#F0F8FF", "#F6FBFF"],
    dark: ["#000000", "#404040", "#707070", "#7F7F7F", "#F4F4F4"],
    light: ["#FFFFFF", "#FCFCFC"],
    error: ["rgb(183, 67, 46)", "rgb(209, 93, 72)", "rgb(219, 129, 112)", "rgb(229, 165, 153)", "rgb(240, 201, 194)"]
  },
  space: spacing,
  fonts: {
    serif: "Lora Bold",
    sansSerif: "Centra"
  },
  fontSizes: fontSizes
});
var _default = workLForBusiness;
exports["default"] = _default;